export default "__VITE_ASSET__DmeyeX43__"